export default __webpack_public_path__ + "static/media/facility-mgt.868dafc8.svg";